function Terms(props){
    return <div className={props.topOpen? "card card-collapsed" : "card"} id="termsCard">
        <div className="card_header">
            <a onClick={() => props.toggleCards()} className="card_header_title"><h2>terms</h2></a>
        </div>
        <div className="card_body">
            <div className="card_body_content">
                <h3>prices</h3>
                <h4>(click to enlarge)</h4>
                <div className="inline_image_row">
                    <div className="inline_image_row_wrapper">
                        <img className="inline_image" src="/prices/04-26.1.png" onClick={()=>props.setImageLightbox("/prices/04-26.1.png")}/>
                    </div>
                    <div className="inline_image_row_wrapper">
                        <img className="inline_image" src="/prices/04-26.2.png" onClick={()=>props.setImageLightbox("/prices/04-26.2.png")}/>
                    </div>
                </div>
                <p>Prices are subject to change until payment is agreed upon. Ultimately, the math for what a piece costs may not always be clean, in which case price is decided by artist fiat.</p>
                <h3>contact</h3>
                <p>When open, commission requests will be accepted through Twitter, Mastodon, or Bluesky direct messages.</p>
                <p>The only other way you can expect me to contact you is over email, when the commission is finished.</p>
                <h3>process</h3>
                <p>Sketch begins after payment is agreed upon. An invoice will be sent after sketch is completed to customer satisfaction. Work on the commission will continue when invoice has been paid. When the piece is finished, you will receive it in your email inbox.</p>
            </div>
        </div>
    </div>;
}
export default Terms;